import { render, staticRenderFns } from "./AuthButtonConfig.vue?vue&type=template&id=d61beb86&scoped=true&"
import script from "./AuthButtonConfig.vue?vue&type=script&lang=js&"
export * from "./AuthButtonConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61beb86",
  null
  
)

export default component.exports